import { Link } from "react-router-dom";

export default function Logo({ to = "/", size = 24, className = "" }) {
  const content = (
    <span className={`z-logo ${className}`} style={{ fontSize: size }}>
      <span className="z-z">z</span>events
    </span>
  );
  if (to) return <Link to={to} style={{ textDecoration: "none" }} data-testid="brand-logo">{content}</Link>;
  return content;
}
